import { createApp } from 'vue';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';

import { i18n } from '@/locales';

import BootstrapVue3 from "bootstrap-vue-next";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

import axios from 'axios';
import VueAxios from 'vue-axios';

createApp(App).use(i18n).use(store).use(router).use(BootstrapVue3).use(VueAxios, axios).mount('#app');